export default {
    inserted(el, binding) {
        // if it has a value, it must be true, otherwise it is also true
        // eslint-disable-next-line no-prototype-builtins
        if (binding.hasOwnProperty("value")) {
            if (binding.value) el.focus();
        } else {
            el.focus();
        }
    },
};
